<modal>
  <span header class="uppercase">{{'Hàng xuất đơn' | lang}} {{tag}} <span *ngIf="SKU">{{'mã' | lang}} {{SKU}}</span> <span *ngIf="color"> {{'màu' | lang}} {{color}}</span> ({{range.name}})</span>

  <text-filter [target]="details" class="std-margin-bottom" [placeholder]="'Tìm đơn'"></text-filter>

  <table responsive class="data">
    <tr>
      <th priority="7" class="text-right" style="width: 0">STT</th>
      <th priority="1"><sortable [target]="details" [extractor]="extractor('Tag')">{{'Đơn xuất' | lang}}</sortable></th>
      <th priority="3" class="text-right"><sortable [target]="details" [extractor]="extractor('LengthQuantity')">{{'Hàng mét' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="details" [extractor]="extractor('WeightQuantity')">{{'Hàng cân' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="details" [extractor]="extractor('ReducedQuantity')">{{'Khấu trừ' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="details" [extractor]="extractor('QuoteQuantity')">{{'Tính tiền' | lang}}</sortable></th>
      <th priority="6" class="text-right"><sortable [target]="details" [extractor]="extractor('BasePrice')">{{'Giá nhập' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="details" [extractor]="extractor('QuotePrice')">{{'Giá bán' | lang}}</sortable></th>
      <th priority="2" class="text-right"><sortable [target]="details" [extractor]="extractor('Value')">{{'Thành tiền' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of details.pageMatches; index as ix" class="text-top">
      <td><small>{{ix + 1 + details.pageIndex * details.pageSize}}</small></td>
      <td>
        <invoice [tag]="i.Path[0]" [displays]="{ partner: true }" [filters]="{ importTag: tag, sku: SKU, color: color }"></invoice>
      </td>
      <td>
        <div><span class="text-success">{{i.Exports.LengthQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <small><b class="text-success">{{i.Exports.LengthCount | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit></small>
      </td>
      <td>
        <div><span class="text-success">{{i.Exports.WeightQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
        <small><b class="text-success">{{i.Exports.WeightCount | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit></small>
      </td>
      <td>
        <div><span class="text-danger">{{i.Exports.LengthQuantity - i.Exports.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div><span class="text-danger">{{i.Exports.WeightQuantity - i.Exports.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td>
        <div><span class="text-success">{{i.Exports.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div><span class="text-success">{{i.Exports.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td>
        {{i.Exports.BaseWorth / (i.Exports.LengthQuoteQuantity + i.Exports.WeightQuoteQuantity) | number : '1.1-1' : 'en-US'}}<cny-per-unit [type]="i.Exports.LengthCount > 0 ? (i.Exports.WeightCount > 0 ? 0 : 1) : 2"></cny-per-unit>
      </td>
      <td>
        {{i.Exports.QuoteValue / (i.Exports.LengthQuoteQuantity + i.Exports.WeightQuoteQuantity) | number : '1.0-0' : 'en-US'}}<vnd-per-unit [type]="i.Exports.LengthCount > 0 ? (i.Exports.WeightCount > 0 ? 0 : 1) : 2"></vnd-per-unit>
        <div class="small">
          {{i.Exports.QuoteWorth / (i.Exports.LengthQuoteQuantity + i.Exports.WeightQuoteQuantity) | number : '1.1-1' : 'en-US'}}<cny-per-unit [type]="i.Exports.LengthCount > 0 ? (i.Exports.WeightCount > 0 ? 0 : 1) : 2"></cny-per-unit>
        </div>
      </td>
      <td>
        <b class="text-success">{{i.Exports.QuoteValue | number : '1.0-0' : 'en-US'}}</b><vnd></vnd>
        <div class="small">
          {{i.Exports.QuoteWorth | number : '1.1-1' : 'en-US'}}<cny></cny>
        </div>
      </td>
    </tr>

    <tr *ngIf="details.pages.length > 1">
      <td [colSpan]="9" style="display: table-cell !important" class="text-center"><pagination [target]="details"></pagination></td>
    </tr>

    <tr class="footer bold text-top" *ngIf="details.matches.length > 1">
      <td></td>
      <td>{{'TỔNG' | lang}} ({{details.matches.length}})</td>
      <td>
        <div>{{sum('LengthQuantity') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <small *ngIf="sum('LengthCount') > 0">{{sum('LengthCount') | number : '1.0-0' : 'en-US'}}<unit>cây</unit></small>
      </td>
      <td>
        <div>{{sum('WeightQuantity') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
        <small *ngIf="sum('WeightCount') > 0">{{sum('WeightCount') | number : '1.0-0' : 'en-US'}}<unit>cây</unit></small>
      </td>
      <td>
        <div *ngIf="sum('LengthCount') > 0">{{sum('LengthQuantity') - sum('LengthQuoteQuantity') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <div *ngIf="sum('WeightCount') > 0">{{sum('WeightQuantity') - sum('WeightQuoteQuantity') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
      </td>
      <td>
        <div *ngIf="sum('LengthCount') > 0">{{sum('LengthQuoteQuantity') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <div *ngIf="sum('WeightCount') > 0">{{sum('WeightQuoteQuantity') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
      </td>
      <td>{{sum('Base') / sum('QuoteQuantity') | number : '1.1-1' : 'en-US'}}<cny-per-unit [type]="sum('LengthCount') > 0 ? (sum('WeightCount') > 0 ? 0 : 1) : 2"></cny-per-unit></td>
      <td>
        {{sum('Value') / sum('QuoteQuantity') | number : '1.0-0' : 'en-US'}}<vnd-per-unit [type]="sum('LengthCount') > 0 ? (sum('WeightCount') > 0 ? 0 : 1) : 2"></vnd-per-unit>
        <div class="small">{{sum('Quote') / sum('QuoteQuantity') | number : '1.1-1' : 'en-US'}}<cny-per-unit [type]="sum('LengthCount') > 0 ? (sum('WeightCount') > 0 ? 0 : 1) : 2"></cny-per-unit></div>
      </td>
      <td>
        {{sum('Value') | number : '1.0-0' : 'en-US'}}<vnd></vnd>
        <div class="small">{{sum('Quote') | number : '1.1-1' : 'en-US'}}<cny></cny></div>
      </td>
    </tr>
  </table>
</modal>
